<div class="parent" [ngClass]="[statusClass, messageClass]">
  <div class="task">
    <div class="status">{{ status }}</div>
    <div class="rows">
      <app-task-user [task]="task"></app-task-user>
      <app-task-actions [task]="task" [tagsContext]="tagsContext" (taskChange)="taskChanged($event)"></app-task-actions>
    </div>
    <div class="rows content">
      <app-task-message [task]="task" [tagsContext]="tagsContext"></app-task-message>
      <app-task-attachments [task]="task"></app-task-attachments>
    </div>
  </div>
  <app-task-infos [task]="task"></app-task-infos>
  <app-task-selection
    *ngIf="taskListMode === taskListModeEnum.Inbox || taskListMode === taskListModeEnum.Search"
    [task]="task"
    [taskListConfiguration]="taskListConfiguration"
    [taskListMode]="taskListMode"></app-task-selection>
</div>
